export const formatGradeValue = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return String(value);
  }

  const roundedValue = Math.round((numericValue + Number.EPSILON) * 100) / 100;
  return roundedValue.toString();
};

export const formatGradePercent = (grade) => formatGradeValue(grade * 100);

export const formatGradeScore = (earned, possible, separator = '/') => (
  `${formatGradeValue(earned)}${separator}${formatGradeValue(possible)}`
);

export const shouldHideProblemScores = (subsection) => subsection.showCorrectness === 'never';
